import {
  HomeOrderPoup,
  HomePromotionPoup,
  HomePromotionActivityPoup,
  HomeGamePoup,
  HomeVideoList,
  VRShowTapeGuidePoup,
  WelcomeAdPoup,
  HomeThreeCarPoup,
} from './poup';
/**
 * 首屏自动弹出层逻辑
 */
export class HomePoup {
  constructor () {
    this.preventOther = false;
    this.poupsQueue = [];
  }
  /**
   * 打开首屏弹层
   * 这些弹层和开屏广告互斥，如果打开这些弹层，开屏广告不再打开
   * @param {*} queryParams
   * @param {*} state
   */
  open (queryParams, state, vrParams) {
    const gameList = state.functionData.gameList;
    const adData = state.functionData.welcomeAd;
    const salesId = state.sales.salesInfo.salesId || 0;
    const videoNum = state.functionData.videoNumInfo;
    const icsShowState = state.busiIcsApp.icsShowState;
    const poupsQueue = [new HomeOrderPoup(queryParams),
    new HomePromotionPoup(queryParams),
    new HomePromotionActivityPoup(queryParams),
    new HomeGamePoup(queryParams, gameList, salesId),
    new HomeVideoList(queryParams, videoNum),
    new VRShowTapeGuidePoup(queryParams, vrParams.isInWorkTime, vrParams.hasIm, state.functionData.imInfo),
    new WelcomeAdPoup(queryParams, adData, icsShowState),
    new HomeThreeCarPoup(queryParams),
    ];
    this.add(poupsQueue);
    return this.execute();
  }
  /**
   * 弹层执行
   */
  execute () {
    for (let index = 0; index < this.poupsQueue.length; index++) {
      const poup = this.poupsQueue[index];
      this.preventOther = poup.execute();
      if (this.preventOther) {
        break;
      }
    }
    this.clear();
  }
  /**
   * 清空
   */
  clear () {
    this.poupsQueue.length = 0;
  }
  /**
   * 新增
   * @param {*} poups
   * @returns
   */
  add (poups) {
    if (this.preventOther) {
      return;
    }
    if (Array.isArray(poups)) {
      this.poupsQueue.push(...poups);
    } else {
      this.poupsQueue.push(poups);
    }
    this.execute();
  }
  reset () {
    this.preventOther = false;
  }
};
const homePoup = new HomePoup();
export default homePoup;

